import styled from 'styled-components'

export const Footer = styled.footer`
  font-size: var(--font-size-sm);
  margin-top: 64px;
  text-align: center;

  a {
    color: var(--text-tertiary);
  }
`
